import { requestData, requestList } from '@/api/request';
import type {
  AdminUser,
  Invite,
  InviteAcceptPayload,
  InviteAcceptResponse,
  InvitePayload,
} from '@/api/types';

export type GetInvitesOptions = {
  status?: 'pending' | 'accepted' | 'cancelled';
  pageSize?: number;
};

export async function getAdminUsers() {
  return requestList<AdminUser>({
    url: 'users/',
  });
}

export async function deactivateAdminUser(id: number) {
  return requestData<AdminUser>({
    url: `users/${id}/deactivate/`,
    method: 'post',
  });
}

export async function reactivateAdminUser(id: number) {
  return requestData<AdminUser>({
    url: `users/${id}/reactivate/`,
    method: 'post',
  });
}

export async function getInvites({ status = 'pending', pageSize = 100 }: GetInvitesOptions = {}) {
  return requestList<Invite, never, { status: string; page_size: number }>({
    url: 'invites/',
    params: {
      status,
      page_size: pageSize,
    },
  });
}

export async function createInvite(payload: InvitePayload) {
  return requestData<Invite, InvitePayload>({
    url: 'invites/',
    method: 'post',
    data: payload,
  });
}

export async function resendInvite(id: number) {
  return requestData<Invite>({
    url: `invites/${id}/resend/`,
    method: 'post',
  });
}

export async function cancelInvite(id: number) {
  await requestData<void>({
    url: `invites/${id}/`,
    method: 'delete',
  });
}

export async function acceptInvite(payload: InviteAcceptPayload) {
  return requestData<InviteAcceptResponse, InviteAcceptPayload>({
    url: 'invite-accept/',
    method: 'post',
    data: payload,
    authMode: 'public',
  });
}